import React from "react";
import Arrow from "@/assets/icons/Arrow";
import { useTheme } from "@/components/ThemeProvider/ThemeProvider";

function ArrowWrapper() {
  const { theme } = useTheme();

  const arrowColor = theme === "light" ? "#0060DD" : "#FFFFFF";

  return <Arrow color={arrowColor} width="11" height="9" />;
}

export default ArrowWrapper;
